import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import "./addedit.scss";

import { useNavigate } from "react-router-dom";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { loginReducer, sidebarReducer } from "../../Redux/store";
import "react-phone-number-input/style.css";

// import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
// import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isPossiblePhoneNumber } from 'libphonenumber-js';

import { useLocation } from "react-router-dom";

function AddEdit({ isEditing }) {


  const navigate = useNavigate();
  const [rolesList, setRolesList] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const [userID, setUserID] = useState("");
  const [missingFields, setMissingFields] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  const [buttonclicked, setButtonclicked] = useState(false);


  const roleOptions = ["Admin", "Manager", "Employee"];
  const heading =
    window.location.pathname === "/edit" ? "Edit New User" : "Create New User";
  // console.log("window.location.pathname", window.location.pathname)
  const submitbutton =
    window.location.pathname === "/edit" ? "Update User" : "Create User";
  const customStyles = {

    option: (provided, state) => ({
      ...provided,

      color: state.isSelected ? "white" : "white",
      backgroundColor: state.isSelected ? "#666666" : "#1A1A1A",
    }),
  };
  const handButtonclick = () => {
    setButtonclicked(true);

  }



  const [formData, setFormData] = useState({
    name: "",
    email: "",
    te_userdeactivatedat: "",
    te_useractivatedat: "",
    phone: "",
    isPhoneValid: false,
    te_role_id: "",
  });

  const validateForm = (formData) => {


    if (!formData.name.trim() && !missingFields.includes("name")) {
      missingFields.push("name");
    }
    if (!formData.email.trim() && !missingFields.includes("email")) {
      missingFields.push("email");
    }
    if (!missingFields.includes("phone") && formData.isPhoneValid == false) {
   
      missingFields.push("phone");
    }

    if (!missingFields.includes("te_role_id") && selectedOption == "") {
      missingFields.push("te_role_id");
    }

    setMissingFields(missingFields);
    return missingFields.length === 0;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userParam = params.get("user");
    getRolesList()
    if (userParam) {


      getUserById(userParam);
      setUserID(userParam);

    }
  }, [location]);







  const [initialFormData, setInitialFormData] = useState({});
  const [isFormChanged, setIsFormChanged] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/edit") {
      // Assuming you have already loaded `formData` for edit
      setInitialFormData(formData);
    }
  }, [formData]);


  const checkFormChanges = (newFormData) => {
    const keys = Object.keys(initialFormData);
    for (let key of keys) {
      if (initialFormData[key] !== newFormData[key]) {
        return true; // If any field is different
      }
    }
    return false; // No fields are different
  };















  const getUserById = async (userParam) => {

    if (userParam) {
      const response = await axios.get(
        "cmsuser/listAllUserByuserid/" + userParam,
        {
          headers: {
            Authorization:
              "Bearer" + " " + sessionStorage.getItem("access_token"),
          },
        }
      );
      if (response.status === 200) {


        setFormData({
          name: response.data.data[0].te_username,
          email: response.data.data[0].te_useremail,
          te_userdeactivatedat: formatDate(response.data.data[0].te_userdeactivatedat),
          te_useractivatedat: formatDate(response.data.data[0].te_useractivatedat),
          te_role_id: response.data.data[0].te_role_id,
          phone: response.data.data[0].te_phone,
        });
        setSelectedOption(response.data.data[0].te_role_id)

      }
    } else {

    }
  };

  const UpdateUser = async (orderFormValues) => {



    let userValues = {
      username: orderFormValues.name,
      firstname: orderFormValues.name,
      lastname: " ",
      "te_useractivatedat": orderFormValues.te_useractivatedat,
      "te_userdeactivatedat": orderFormValues.te_userdeactivatedat,
      email: orderFormValues.email,
      phone: orderFormValues.phone,
      usertype: "platform",
      divisionid: "1",
      roleid: orderFormValues.te_role_id,
      te_isallowedforunityapp: "false",
      companyid: JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
    };
    try {
      const response = await axios.put("cmsuser/update/" + userID, userValues, {
        headers: {
          Authorization:
            "Bearer" + " " + sessionStorage.getItem("access_token"),
        },
      });
      console.log("response", response);

      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {

        if (response.data.message === "CMS USER UPDATED SUCCESSFULLY") {
          toast.success("USER UPDATED SUCCESSFULLY", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            onClose: () => navigate("/list-users")
          });
          setFormData({
            name: "",
            email: "",
            te_userdeactivatedat: "",
            te_useractivatedat: "",
            phone: "",
            isPhoneValid: false,
            te_role_id: "",
          });
          setSelectedOption("");
          setMissingFields([]);
          setButtonclicked(false);

        }
        else {
          toast.warn(response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(error.response.data.data[0].msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("Error fetching company details:", error);
    }
  };

  const createUSer = async (orderFormValues) => {


    let userValues = {
      username: orderFormValues.name,
      firstname: orderFormValues.name,
      lastname: " ",
      email: orderFormValues.email,
      phone: orderFormValues.phone,
      "te_useractivatedat": orderFormValues.te_useractivatedat,
      "te_userdeactivatedat": orderFormValues.te_userdeactivatedat,
      usertype: "platform",
      divisionid: "1",
      roleid: orderFormValues.te_role_id,
      te_isallowedforunityapp: "false",
      companyid: JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
    };
    try {
      const response = await axios.post("/cmsuser/add", userValues, {
        headers: {
          Authorization:
            "Bearer" + " " + sessionStorage.getItem("access_token"),
        },
      });
      console.log("response", response);

      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {

        if (response.data.message === "CMS USER ADDED SUCCESSFULLY") {

          toast.success("USER ADDED SUCCESSFULLY", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            onClose: () => navigate("/list-users")
          });

          setFormData({
            name: "",
            email: "",
            te_userdeactivatedat: "",
            te_useractivatedat: "",
            phone: "",
            isPhoneValid: false,
            te_role_id: "",
          });
          setSelectedOption("");
          setMissingFields([]);
          setButtonclicked(false);

        }
        else {
          console.log("elseresponse", response);
          toast.warn(response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

      }
      else {
        console.log("elseresponse", response);
        toast.warn(response.data.data, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      // console.log("abbb",error.response.data.data)
      toast.warn(error.response.data.data, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      if (error.response.data.data.msg) {
        toast.error(error.response.data.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      console.error("Error fetching company details:", error);
    }
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    console.log("emailRegex.test(email)", emailRegex.test(email));
    return emailRegex.test(email);
  };
  const validateName = (name) => {
    const nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
    console.log("emailRegex.test(email)", nameRegex.test(name));
    return nameRegex.test(name);
  };
  const handleChange = (e) => {

    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    setIsFormChanged(checkFormChanges(updatedFormData));

    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "email") {
      if (!validateEmail(e.target.value)) {
        console.error("Please enter a valid email address.");
        if (!missingFields.includes("email")) {
          missingFields.push("email");
        }


      } else {
        let missingitems = missingFields.filter((item) => item !== "email");
        setMissingFields(missingitems);
      }
    }
    if (e.target.name === "name") {
      if (e.target.value) {

        if (!validateName(e.target.value)) {
          console.error("Please enter a valid name.");
          if (!missingFields.includes("name")) {
            missingFields.push("name");
          }


        } else {
          let missingitems = missingFields.filter((item) => item !== "name");
          setMissingFields(missingitems);
        }

      }
    }
    if (e.target.name === "phone") {
      if (e.target.value) {
        let missingitems = missingFields.filter((item) => item !== "phone");
        setMissingFields(missingitems);
      }
    }


  };
  const handleRoleChange = (e) => {
    if (e.target.value) {
      console.log("e.value", e.target.value);
      setSelectedOption(e.target.value);
      setFormData({ ...formData, te_role_id: e.target.value });
      let missingitems = missingFields.filter((item) => item !== "te_role_id");
      setMissingFields(missingitems);
    }
  };
  async function getRolesList() {
    dispatch(sidebarReducer.apiLoad(true));

    await axios

      .get("roles/list", {
        headers: {
          'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token")
        }
      })


      .then((response) => {
        // console.log(" response list users", response.data.data)
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));

          // console.log("getAllUsers2", response.data.data.rows)
          setRolesList(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  const [phoneError, setPhoneError] = useState("");

  const handlePhoneChange = (value, country, e, formattedValue) => {
    let phoneError = "";

    if (value) {

      if (isPossiblePhoneNumber(formattedValue, country.dialCode) === false) {
        phoneError = "Phone number is invalid";
      } else if (country.dialCode === '91' && formattedValue.length !== 15) {
        phoneError = "Phone number is invalid";
      } else if (country.dialCode === '91') {
        const indianMobilePattern = /^\+91[6-9]\d{9}$/;
        const cleanedFormattedValue = formattedValue.replace(/[^+\d]/g, '');
        const isValidIndianNumber = indianMobilePattern.test(cleanedFormattedValue);
        if (!isValidIndianNumber) {
          phoneError = "Phone number is invalid";
        }
      }

      if (phoneError) {
        setFormData({ ...formData, phone: value, isPhoneValid: false });
        if (!missingFields.includes("phone")) {
          setMissingFields([...missingFields, "phone"]);
        }
      } else {
        setFormData({ ...formData, phone: value, isPhoneValid: true });
        let missingitems = missingFields.filter((item) => item !== "phone");
        setMissingFields(missingitems);
      }
    } else {
      setFormData({ ...formData, phone: "", isPhoneValid: false });
      if (!missingFields.includes("phone")) {
        setMissingFields([...missingFields, "phone"]);
      }
    }

    // Store the phone error message in the component's state
    setPhoneError(phoneError);
  };

  // const handlePhoneChange = (value, country, e, formattedValue) => {

  //   if (value) {
  //     if (isPossiblePhoneNumber(formattedValue) == true) {

  //       setFormData({ ...formData, phone: value, isPhoneValid: true });

  //       let missingitems = missingFields.filter((item) => item !== "phone");
  //       setMissingFields(missingitems);

  //     } else {

  //       setFormData({ ...formData, isPhoneValid: false });


  //       if (!missingFields.includes("phone")) {
  //         missingFields.push("phone");
  //       }
  //     }
  //   }




  //   console.log("value.replace(/D/g, '').length", value);

  //   console.log("country.format?.replace(/D/g, '').length", country);
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonclicked(true);

    if (window.location.pathname === "/edit" && !isFormChanged) {
      toast.info("No changes detected", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    if (window.location.pathname === "/edit") {
      UpdateUser(formData);
    }


    console.log("formData......", formData);
    if (validateForm(formData)) {
      console.log("validatedddd");
      window.location.pathname === "/edit"
        ? UpdateUser(formData)
        : createUSer(formData);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const today = formatDate(new Date());

  const getNextDay = (date) => {
    let nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    return formatDate(nextDay);
  };

  const getPreviousDay = (date) => {
    let previousDay = new Date(date);
    previousDay.setDate(previousDay.getDate() - 1);
    return formatDate(previousDay);
  };

  function clearenteredData() {
    document.getElementById("ClearData").reset();
  }

  const minDeactivationDate = formData.te_useractivatedat
    ? getNextDay(formData.te_useractivatedat)
    : getNextDay(today);

  const maxActivationDate = formData.te_userdeactivatedat
    ? getPreviousDay(formData.te_userdeactivatedat)
    : "";

  return (
    <div className="add-edit">
      <ToastContainer closeButton={false} />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <SearchBarComponent className="search-bar-div" />
          </div>
        </div>
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div
              className="addedit-container"
              style={{
                display: "flex",
                flexDirection: "column",
                height: "auto",
              }}
            >

              <h3 className="heading-h1">{heading}</h3>
              <br></br>
              {/* First Row */}
              <div
                style={{ display: "flex", gap: "40px", paddingBottom: "20px" }}
              >
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    className={`${missingFields.includes("name") ? "missing-field" : ""
                      }`}
                    onChange={handleChange}
                    placeholder="Enter Full Name"
                  />
                  {formData.name === "" && buttonclicked ? (
                    <p style={{ color: "red" }}>Please enter a Name.</p>
                  ) : (
                    <p
                      style={{
                        display: missingFields.includes("name")
                          ? "block"
                          : "none",
                        color: "#C91616",
                      }}
                    >
                      Please enter a valid Name.
                    </p>
                  )}
                </div>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className={`${missingFields.includes("email") ? "missing-field" : ""
                      }`}
                    m
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your Email"
                  />
                  {formData.email === "" && buttonclicked ? (
                    <p style={{ color: "red" }}>Please enter a Email.</p>
                  ) : (
                    <p
                      style={{
                        display: missingFields.includes("email")
                          ? "block"
                          : "none",
                        color: "#C91616",
                      }}
                    >
                      Please enter a valid email address.
                    </p>
                  )}


                </div>
              </div>

              <br></br>

              {/* Second Row */}
              <div
                style={{ display: "flex", gap: "40px", paddingBottom: "20px" }}
              >
                <div className="align" style={{ flex: 1 }}>

                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Phone
                  </label>

                  <PhoneInput
                    country={'in'}
                    enableSearch={true}
                    className={`${missingFields.includes("phone") ? "missing-field" : ""}`}
                    placeholder="Enter Phone Number"
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    inputProps={{
                      name: "phone",
                      className: "form-control", // Use the default class name applied by react-tel-input
                    }}
                  />


                  {/* {formData.phone === "" && buttonclicked ? (
                    <p style={{ color: "red" }}>Please enter a Phone Number.</p>
                  ) : (
                    <p
                      style={{
                        display: missingFields.includes("phone")
                          ? "block"
                          : "none",
                        color: "#C91616",
                      }}
                    >
                      Please enter a Phone Number.
                    </p>
                  )} */}
                  {formData.phone === "" && buttonclicked ? (
                    <p style={{ color: "red" }}>Please enter a Phone Number.</p>
                  ) : phoneError ? (
                    <p style={{ color: "red" }}>{phoneError}</p>
                  ) : (
                    <p
                      style={{
                        display: missingFields.includes("phone") ? "block" : "none",
                        color: "#C91616",
                      }}
                    >
                      Please enter a valid Phone Number.
                    </p>
                  )}
                </div>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    {" "}
                    <span style={{ color: "#C91616" }}>*</span> Role Type
                  </label>
                  <select
                    id='dropdown'

                    value={formData.te_role_id || ''}
                    onChange={handleRoleChange}
                    name='te_role_id'
                  >
                    <option value="" disabled>Select Role</option> {/* Disabled option */}
                    {rolesList &&
                      rolesList.map((role) => (
                        <option key={role.te_role_id} value={role.te_role_id}>
                          {role.te_role_name}
                        </option>
                      ))}
                  </select>


                  {formData.te_role_id == "" && buttonclicked && (
                    <p style={{ color: "red" }}>Please select a Role Type.</p>
                  )}

                </div>

              </div>
              <br></br>

              {/* Third Row */}
              <div
                style={{ display: "flex", gap: "40px", paddingBottom: "36px" }}
              >
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    {" "}
                    <span style={{ color: "#C91616" }}>*</span> Activation Date
                  </label>
                  <input
                    type="date"
                    id="te_useractivatedat"
                    name="te_useractivatedat"
                    value={formData.te_useractivatedat}
                    onChange={handleChange}
                    min={today}
                    max={maxActivationDate}
                    className="date-input"
                    onKeyDown={(e) => {
                      if (e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                  />     {formData.te_useractivatedat == "" && buttonclicked && (
                    <p style={{ color: "red" }}>
                      Please select Activation Date
                    </p>
                  )}
                </div>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    {" "}
                    <span style={{ color: "#C91616" }}>*</span> Deactivation
                    Date
                  </label>
                  <input
                    type="date"
                    id="te_userdeactivatedat"
                    name="te_userdeactivatedat"
                    value={formData.te_userdeactivatedat}
                    onChange={handleChange}
                    min={minDeactivationDate}
                    className="date-input"
                    onKeyDown={(e) => {
                      if (e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                  /> {formData.te_userdeactivatedat == "" && buttonclicked && (
                    <p style={{ color: "red" }}>
                      Please select Deactivation Date
                    </p>
                  )}
                </div>
                <div className="align" style={{ flex: 1 }}></div>
              </div>
              <div className="button-component">
                <button
                  style={{ marginBottom: "30px" }}
                  type="submit"
                  className="create-button"
                  onClick={handButtonclick}
                  disabled={window.location.pathname === "/edit" && !isFormChanged}
                >
                  {submitbutton}
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}

export default AddEdit;
